import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/index.css";
import RouterSwitch from "./app/RouterSwitch";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <RouterSwitch />
  </React.StrictMode>
);
